import classNames from 'classnames';

export default function TextButton({text,onClick,className,red=false,lucideIcon}){

    return(
        <div className={classNames(className,"cursor-pointer flex justify-center items-center gap-3 border rounded-full group  px-5 py-1 ",(red?"border-red hover:bg-red":"border-medium-green hover:bg-medium-green"))} onClick={onClick}>
            {lucideIcon}
            <p className={"font-medium group-hover:text-white "+(red?"text-red":"text-medium-green")}>{text}</p>
        </div>
    )
}